import { existsInDb, updateDbStore, encryptValue, createOrOpenDB, decryptValue, getDbStore, } from 'oasis-os-utils';
export const dbConfig = {
    name: 'oasis-pwa',
    version: 2,
    stores: ['share_resources', 'user_collections'],
};
export const getCacheKey = ({ params, endpoint }) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        value !== undefined && query.append(key, String(value));
    });
    return `${endpoint}?${query.toString()}`;
};
export const fetchCache = async (storeName, key) => {
    return createOrOpenDB(dbConfig.name, dbConfig.version, dbConfig.stores)
        .then(async (database) => {
        return getDbStore({ database, storeName, key })
            .then(async (response) => {
            if (response !== null) {
                const decryptedValue = JSON.parse(await decryptValue(response));
                return decryptedValue;
            }
            else {
                return null;
            }
        })
            .catch(() => {
            return null;
        });
    })
        .catch(() => {
        return null;
    });
};
export const persistCache = async (storeName, key, value) => {
    const encryptedValue = (await encryptValue(JSON.stringify(value)));
    return createOrOpenDB(dbConfig.name, dbConfig.version, dbConfig.stores)
        .then(async (database) => {
        return updateDbStore({
            database,
            storeName,
            key,
            value: encryptedValue,
        })
            .then(async (result) => {
            const decryptedValue = JSON.parse(await decryptValue(result.value));
            return {
                value: decryptedValue,
                dataUpdated: result.dataUpdated,
            };
        })
            .catch(() => {
            return { value, dataUpdated: false };
        });
    })
        .catch(() => {
        return { value, dataUpdated: false };
    });
};
export const validateCache = async (storeName, key, value) => {
    const encryptedValue = (await encryptValue(JSON.stringify(value)));
    return createOrOpenDB(dbConfig.name, dbConfig.version, dbConfig.stores)
        .then(async (database) => {
        return existsInDb({
            database,
            storeName,
            key,
            value: encryptedValue,
        })
            .then(async (result) => {
            return { dataUpdated: !result };
        })
            .catch(() => {
            return { dataUpdated: false };
        });
    })
        .catch(() => {
        return { dataUpdated: false };
    });
};
